/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { TTableColumnCell } from '../../../types';
import { TableCell } from '../../Cell';
import CheckboxCell from './CheckboxCell';
import { TTableCheckboxColumn } from './types';

function TableColumnCheckbox<D extends { checked: boolean }>(cell: TTableCheckboxColumn<D>): TTableColumnCell<D> {
    return {
        accessor: 'checked',
        Cell: props => TableCell(props)({
            render: ({ row }) => <CheckboxCell {...cell(row)} />,
        }),

        sticky: 'left',

        disableResizing: true,

        width: 48,
        minWidth: 48,
    };
}

export default TableColumnCheckbox;
